export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-4xl mx-auto px-6 py-12">
        <h1 className="text-3xl font-bold mb-8">GetBokr Privacy Policy</h1>
        <p className="text-muted-foreground mb-6">Operated by Lifely Holdings Limited</p>
        <p className="text-muted-foreground mb-8">Last Updated: February 2026</p>

        <div className="prose prose-neutral dark:prose-invert max-w-none space-y-8">
          <section>
            <h2 className="text-xl font-semibold mb-4">1. Overview</h2>
            <p>GetBokr is operated by Lifely Holdings Limited, a New Zealand company.</p>
            <p>We are committed to handling personal information in accordance with the Privacy Act 2020 (New Zealand).</p>
            <p>This policy applies globally but is governed by New Zealand law.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">2. What We Collect</h2>
            <p>We collect limited personal information necessary to operate the Service.</p>
            <h3 className="text-lg font-medium mt-4 mb-2">Account Information</h3>
            <ul className="list-disc pl-6 space-y-1">
              <li>Name</li>
              <li>Email</li>
              <li>Business details</li>
            </ul>
            <h3 className="text-lg font-medium mt-4 mb-2">Client Data</h3>
            <p>Data entered by you may include:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Client name</li>
              <li>Email</li>
              <li>Phone number</li>
              <li>Notes</li>
            </ul>
            <p className="mt-2">We do not require sensitive personal data.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">3. Payments</h2>
            <p>We do not store card details.</p>
            <p>Payments are handled by third-party processors.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">4. How We Use Data</h2>
            <p>We use data to:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Operate the platform</li>
              <li>Send notifications</li>
              <li>Maintain security</li>
              <li>Provide support</li>
            </ul>
            <p className="mt-2 font-medium">We do not sell personal data.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">5. Data Responsibility</h2>
            <p>You are the data controller for any client data you store.</p>
            <p>We act as a software provider only.</p>
            <p>You are responsible for compliance with privacy laws in your jurisdiction.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">6. Hosting & Infrastructure</h2>
            <p>We use reputable global infrastructure providers.</p>
            <p>While these providers maintain industry security standards, we do not control their systems and cannot guarantee their performance or security.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">7. Security</h2>
            <p>We take reasonable measures appropriate for a cloud SaaS platform.</p>
            <p>However:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>No system is 100% secure</li>
              <li>We do not guarantee immunity from breaches</li>
              <li>We are not liable for incidents beyond our control</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">8. International Data Transfers</h2>
            <p>Data may be stored or processed outside New Zealand.</p>
            <p>By using the Service, you consent to international data transfer.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">9. Data Retention</h2>
            <p>We retain data while accounts are active and for reasonable operational purposes thereafter.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">10. Your Rights</h2>
            <p>You may request access or correction of personal data by contacting:</p>
            <p className="font-medium">support@getbokr.com</p>
            <p className="mt-2">You may lodge a complaint with the NZ Privacy Commissioner.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">11. Limitation of Liability</h2>
            <p>To the maximum extent permitted by law, we are not liable for:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Third-party failures</li>
              <li>Security incidents</li>
              <li>Data loss beyond our reasonable control</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">12. Updates</h2>
            <p>We may update this policy at any time.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">13. Contact</h2>
            <p>Lifely Holdings Limited</p>
            <p>New Zealand</p>
            <p className="font-medium">support@getbokr.com</p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t">
          <a href="/login" className="text-primary hover:underline">← Back to Login</a>
        </div>
      </div>
    </div>
  );
}
